
import { useAuth } from './utils/AuthContext';
import SuperAdminDashboard from './components/dashboards/SuperAdminDashboard';
import AdminDashboard from './components/dashboards/AdminDashboard';
import UserDashboard from './components/dashboards/UserDashboard';


export default function Dashboard() {
  const { user } = useAuth();

  const roleComponents = {
    super_admin: SuperAdminDashboard,
    admin: AdminDashboard,
    user: UserDashboard,
  };

  const DashboardComponent = roleComponents[user?.role] || UserDashboard;

  return (<DashboardComponent />);

}
